import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ConfigLoadingModal = props => {
  return (
    <div className="config-loading-modal">
      <div>Please wait while Summit is being configured...</div>
      <FontAwesomeIcon className="icon" icon={['far', 'cog']} spin />
    </div>
  )
}

export default ConfigLoadingModal
